import gql from 'graphql-tag';
import IVendorProductGroup, {
  IAttributeFilterInput,
} from '@models/VendorVariant/i-vendor-product-group';

export interface IGetVendorProductGroupByIdData {
  vendorProductGroupById: IVendorProductGroup;
}

export interface IGetVendorProductGroupByIdVars {
  id: string;
  attributeFilters: IAttributeFilterInput[];
}

export default gql`
  query VendorProductGroupById(
      $id: ID!
      $attributeFilters: [VendorProductGroupAttributeFilterInput!]!
  ) {
    vendorProductGroupById(
      id: $id
    ) {
      id
      name
      collectionName
      vendorId
      colors
      vendorProductGrouping {
        id
        url
      }
      blogPosts {
            postId,
            title,
            mediumImage,
            largeImage,
            url
      }
      attributeFilters(attributeFilters: $attributeFilters) {
          attributeTypeId
          title
          options {
              attributeTypeId
              value
              noResults
              selected
          }
      }
      vendorVariants(attributeFilters: $attributeFilters) {
        id
        title
        isOnSale  
        retailPrice {
          id
          price
        }
        attributeValues {
          id
          attributeType {
            id
            title
          }
          value
        }
        currentPrice
        vendorPromotion {
          id
          promoText
          shipping
          terms
        }
        availability
        color
        description
        dimensions
        material
        images {
          id
          uri
          height
          width
        }
        isReturnable
        returnPolicy {
          description
          url
        }
        reviewStats {
          average
          count
        },
        shippingType {
          title
        }
        shippingPolicy {
            description
            url
            urlText
        }
        vendor {
          id
          name
          publicBrandUrl
          doNotUse
        }
        saleOnSalePrice {
        price
        percentage
        }
        vendorTieredDiscountCode {
          code
          discountType
          maxSavingsPercentage
          minSavingsValue
          maxSavingsValue
          lowestDiscountPrice
          highestDiscountPrice
          discountText
          discountTerms
        }
        taxonomy {
          id
          title
          preferredTaxonomyCategory {
              id
              title
              slug
              parentTaxonomyCategory {
                  id
                  title
                  slug
              }
          }
        }
        sku
        weblink
        etaText
        feedCreatorId
        commissionTier {
          id
        }
      }
    }
  }
`;
